// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .datefield{
    ::-webkit-datetime-edit-year-field:not([aria-valuenow]),
::-webkit-datetime-edit-month-field:not([aria-valuenow]),
::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
color: transparent;
}
}
 */

 /* input[type=date]::-webkit-datetime-edit-text {
    -webkit-appearance: none;
    display: none;
} */

/* input[type=date]:required:invalid::-webkit-datetime-edit {
    color: transparent;
}
input[type=date]:focus::-webkit-datetime-edit {
    color: black !important;
} */


/* input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
  } */


  /* .datefield::-webkit-input-placeholder {
    color: transparent;
  }
  
  .datefield:-moz-placeholder {
    color: transparent;
  }
  
  .datefield::-moz-placeholder {
    color: transparent;
  }
  
  .datefield:-ms-input-placeholder {
    color: transparent;
  } */

  .loader {
    border: 4px solid rgba(108, 125, 187, 0.1); /* Light border */
    border-left-color: #001F33; /* Dark border */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/filtersearch.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;CAED;;;GAGE;;AAEH;;;;;GAKG;;;AAGH;;KAEK;;;EAGH;;;;;;;;;;;;;;KAcG;;EAEH;IACE,0CAA0C,EAAE,iBAAiB;IAC7D,0BAA0B,EAAE,gBAAgB;IAC5C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF","sourcesContent":["/* .datefield{\n    ::-webkit-datetime-edit-year-field:not([aria-valuenow]),\n::-webkit-datetime-edit-month-field:not([aria-valuenow]),\n::-webkit-datetime-edit-day-field:not([aria-valuenow]) {\ncolor: transparent;\n}\n}\n */\n\n /* input[type=date]::-webkit-datetime-edit-text {\n    -webkit-appearance: none;\n    display: none;\n} */\n\n/* input[type=date]:required:invalid::-webkit-datetime-edit {\n    color: transparent;\n}\ninput[type=date]:focus::-webkit-datetime-edit {\n    color: black !important;\n} */\n\n\n/* input[type=\"date\"]::-webkit-calendar-picker-indicator {\n    display: none;\n  } */\n\n\n  /* .datefield::-webkit-input-placeholder {\n    color: transparent;\n  }\n  \n  .datefield:-moz-placeholder {\n    color: transparent;\n  }\n  \n  .datefield::-moz-placeholder {\n    color: transparent;\n  }\n  \n  .datefield:-ms-input-placeholder {\n    color: transparent;\n  } */\n\n  .loader {\n    border: 4px solid rgba(108, 125, 187, 0.1); /* Light border */\n    border-left-color: #001F33; /* Dark border */\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
